export const GOVOPS_ENTITLEMENT_MSG =
  'GovOps entitlement required. Sign in with your RobinhoodSpace account; your Firebase UID must have govops access on SD Panthers.';

export class GovOpsEntitlementRequiredError extends Error {
  constructor(message = GOVOPS_ENTITLEMENT_MSG) {
    super(message);
    this.name = 'GovOpsEntitlementRequiredError';
  }
}
